import dayjs from 'dayjs';
import { isDateTodayOrPast } from 'components/datePicker/dateTimepopover/dateAndTimePopover';
import { v4 as uuidv4 } from 'uuid';

import { NoteFormValues } from './validation';

export const isValidDateOrTimeOrNull = (value: any, type: 'date' | 'time') => {
  const parsed = type === 'date' ? dayjs(value) : dayjs(value, ['hh:mm A', 'HH:mm:ss'], true);

  const isValid = parsed.isValid();

  if (isValid) {
    if (type === 'date' && !isDateTodayOrPast(value)) return null;
    return value;
  } else {
    return null;
  }
};

export const defaultValues: NoteFormValues = {
  uuid: uuidv4(),
  note: null,
  draft: null,
  noteType: null,
  clientReached: null,
  dateOfEncounter: null,
  startTimeOfEncounter: null,
  nextContact: null,
  typeOfSupport: [],
  id: null,
  timeSpentMin: null,
  timeSpent: null,
  siteId: null,
  selectedZCodes: [],
  whoDidYouReach: [],
  whoWereYouTryingToReach: '',
  howDidYouTryThem: '',
  howDidYouReachThem: '',
  whatTypeOfPlaceWereYouIn: '',
  billingProviderId: '',
  otherProviderName: '',
  documentationTime: null,
  chwId: null,
  managerId: null
};

export const createDefaultValues = (
  sitesEnabled?: boolean,
  isBillingEnabled?: boolean
): NoteFormValues => ({
  ...defaultValues,
  uuid: uuidv4(),
  sitesEnabled,
  isBillingEnabled
});

export const remapValues = ({
  values,
  clientId,
  id,
  draft
}: {
  values: NoteFormValues;
  clientId?: string;
  id?: string;
  draft?: boolean | null;
}) => {
  let formattedStartTimeOfEncounter = values.startTimeOfEncounter;
  if (dayjs(formattedStartTimeOfEncounter, 'HH:mm:ss').isValid()) {
    formattedStartTimeOfEncounter = dayjs(formattedStartTimeOfEncounter, 'HH:mm:ss').format(
      'hh:mm A'
    );
  }

  return {
    clientId: clientId,
    id: Number(id) ?? null,
    draft: draft ?? null,
    eventTimestamp: new Date().getTime(),
    uuid: values.uuid,
    note: values.note,
    noteType: values.noteType || null,
    clientReached: values.clientReached || null,
    dateOfEncounter: isValidDateOrTimeOrNull(values.dateOfEncounter, 'date'),
    startTimeOfEncounter: formattedStartTimeOfEncounter,
    nextContact: values.nextContact || null,
    typeOfSupport: values.typeOfSupport || null,
    timeSpentMin: values.timeSpentMin,
    siteId: values.siteId ?? null,
    selectedZCodes:
      values.selectedZCodes?.map((z: any) => ({
        ...z,
        selectedExplanations: z.selectedExplanations?.map((e: any) => ({ id: Number(e) })) ?? []
      })) ?? [],
    chwId: values.chwId ?? null,
    billingProviderId: values.billingProviderId ?? null,
    managerId: values.managerId ?? null,
    documentationTime: values.documentationTime ?? null,
    otherProviderName: values.otherProviderName ?? '',
    whoDidYouReach: values.whoDidYouReach ?? [],
    howDidYouReachThem: values.howDidYouReachThem ?? '',
    whoWereYouTryingToReach: values.whoWereYouTryingToReach ?? '',
    howDidYouTryThem: values.howDidYouTryThem ?? '',
    whatTypeOfPlaceWereYouIn: values.whatTypeOfPlaceWereYouIn ?? ''
  };
};

export function removeEmptyFieldsFromObject<T extends Record<string, any>>(obj: T): T {
  const filteredEntries = Object.entries(obj).filter(
    ([_, value]) => value !== undefined && value !== ''
  );
  return Object.fromEntries(filteredEntries) as unknown as T;
}

export const AiScribeIcon = () => {
  return (
    <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.1065 7.00002L17.8965 5.25002L19.6465 4.46002C20.0365 4.28002 20.0365 3.73002 19.6465 3.55002L17.8965 2.76002L17.1065 1.00002C16.9265 0.61002 16.3765 0.61002 16.1965 1.00002L15.4065 2.75002L13.6465 3.54002C13.2565 3.72002 13.2565 4.27002 13.6465 4.45002L15.3965 5.24002L16.1865 7.00002C16.3665 7.39002 16.9265 7.39002 17.1065 7.00002ZM9.14652 8.50002L7.55652 5.00002C7.20652 4.22002 6.08652 4.22002 5.73652 5.00002L4.14652 8.50002L0.646523 10.09C-0.133477 10.45 -0.133477 11.56 0.646523 11.91L4.14652 13.5L5.73652 17C6.09652 17.78 7.20652 17.78 7.55652 17L9.14652 13.5L12.6465 11.91C13.4265 11.55 13.4265 10.44 12.6465 10.09L9.14652 8.50002ZM16.1865 15L15.3965 16.75L13.6465 17.54C13.2565 17.72 13.2565 18.27 13.6465 18.45L15.3965 19.24L16.1865 21C16.3665 21.39 16.9165 21.39 17.0965 21L17.8865 19.25L19.6465 18.46C20.0365 18.28 20.0365 17.73 19.6465 17.55L17.8965 16.76L17.1065 15C16.9265 14.61 16.3665 14.61 16.1865 15Z"
        fill="#188AA1"
      />
    </svg>
  );
};
